import script from "./sub-sidebar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sub-sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./sub-sidebar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sub-sidebar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__